import React from 'react';
import DateTimeReact from 'react-datetime';
import StaticTextInput from '../../StaticTextInput';
import moment from 'moment';
import '../../DateTimeInput.css';
import { FormControl } from '../FormControl';

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_TIME_FORMAT = 'HH:mm';

const DateTimeInput = (props) => {
  const error =
    (props.fieldErrorFlags && props.fieldErrorFlags[props.field]) ||
    props.error;

  const handleChange = (value) => {
    if (moment.isMoment(value)) {
      const formatted =
        props.dateFormat === false
          ? value.format('HH:mm')
          : props.showTime === false
          ? value.format('YYYY-MM-DD')
          : value.format('YYYY-MM-DD HH:mm');
      props.onChange(formatted);
    } else {
      props.onChange(value);
    }
  };

  moment.updateLocale('en', {
    week: {
      dow: 1,
    },
  });

  if (props.readonly) {
    return <StaticTextInput label={props.label} value={props.value && props.value.toString()} />;
  }


  const timeFormat = props.showTime === false ? '' : DEFAULT_TIME_FORMAT;
  const dateFormat = props.showTime === false
    ? DEFAULT_DATE_FORMAT
    : (props.dateFormat !== undefined ? props.dateFormat : `${DEFAULT_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`);
  const closeOnSelect = props.closeOnSelect !== false;
  const placeHolderDateFormat = props.placeholderText
    || (props.showTime === false
      ? DEFAULT_DATE_FORMAT
      : `${DEFAULT_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`);
    

  const normalizeValue = (v) => {
    if (v === null || v === undefined) return undefined;
    if (moment.isMoment(v)) return v;
    if (typeof v === 'string') {
      const m = moment(v, [dateFormat, placeHolderDateFormat, `${DEFAULT_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`, DEFAULT_DATE_FORMAT, DEFAULT_TIME_FORMAT, moment.ISO_8601], true);
      return m.isValid() ? m : undefined;
    }
    if (v instanceof Date) {
      const m = moment(v);
      return m.isValid() ? m : undefined;
    }
    if (typeof v === 'number') {
      const m = moment(v);
      return m.isValid() ? m : undefined;
    }
    return undefined;
  };

  const dtProps = {
    dateFormat: dateFormat,
    timeFormat: timeFormat,
    inputProps: { placeholder: placeHolderDateFormat },
    onChange: handleChange,
    closeOnSelect: closeOnSelect,
    value: normalizeValue(props.value),
    initialValue: normalizeValue(props.initialValue),
    ...(props.isValidDate && { isValidDate: props.isValidDate }),
  };

  return (
    <FormControl controls={{ error, required: props.required }}>
      {props.label && <label>{props.label}</label>}
      <DateTimeReact
        {...dtProps}
        renderInput={(riProps) => {
          return (
            <div className="d-flex">
              <input {...riProps} className="form-control rounded-8" value={riProps.value || ''} />
            </div>
          );
        }}
      />
    </FormControl>
  );
};

export default DateTimeInput;
